import React, { useEffect } from "react";
import { useState } from "react";
import Header from "../master/SideBar";
import { closeModal, SweetAlertShow, LoadingDiv } from "../master/Master";
import Nav from "../master/NavBar";
import Swal from "sweetalert2";
import usePrivateLink from "../config/usePrivateLink";
import {
  librariesList,
  libraryAdd,
  libraryDelete,
  libraryStatusChange,
  libraryUpdate,
} from "../../api/Library";
import LibraryLayout from "./LibraryLayout";

export default function Libraries() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [libraries, setLibraries] = useState([]);
  const [modalData, setModalData] = useState("");

  const getDataList = async () => {
    setLoading(true);
    try {
      const response = await librariesList();
      if (response.data?.status) {
        setLibraries(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataList();
  }, []);

  const createLibrary = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await libraryAdd(formData);
      if (response?.data?.status) {
        e.target.reset();
        closeModal("addNewLibrary");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getDataList();
    }
  };

  const handleStatusChange = async (id) => {
    setLoading(true);
    try {
      const response = await libraryStatusChange(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message,
      );
    } finally {
      setLoading(false);
      getDataList();
    }
  };

  const updateLibrary = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await libraryUpdate(formData);
      if (response?.data?.status) {
        closeModal("editLibrary");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getDataList();
    }
  };

  const deleteLibrary = async (id) => {
    setLoading(true);
    try {
      const response = await libraryDelete(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getDataList();
    }
  };

  const [search, setSearch] = useState("");

  const filteredLibraries = libraries.filter((item) => {
    const searchTerm = search.toLowerCase();

    return (
      item.name?.toLowerCase().includes(searchTerm) ||
      item.mobile?.toString().toLowerCase().includes(searchTerm) || // ✅ toString() added
      item.address?.toLowerCase().includes(searchTerm)
    );
  });

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="row">
                      <h3 className="mb-0 text-primary">Overview</h3>
                      <p className="m-0">
                        Monitor growth and performance across library and
                        students
                      </p>
                      <div className="col-sm-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body d-flex align-items-center">
                            <div
                              className="avatar bg-label-primary rounded me-3 d-flex align-items-center justify-content-center"
                              style={{
                                width: "70px",
                                height: "70px",
                                minWidth: "70px",
                              }}
                            >
                              <i className="ri-building-line fs-2"></i>
                            </div>
                            <div>
                              <small className="text-muted">
                                Total Libraries
                              </small>
                              <h3 className="mb-0">{libraries.length}</h3>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body d-flex align-items-center">
                            <div
                              className="avatar bg-label-success rounded me-3 d-flex align-items-center justify-content-center"
                              style={{
                                width: "70px",
                                height: "70px",
                                minWidth: "70px",
                              }}
                            >
                              <i className="ri-graduation-cap-line fs-2"></i>
                            </div>
                            <div>
                              <small className="text-muted">
                                Total Students
                              </small>
                              <h3 className="mb-0">
                                {libraries.reduce(
                                  (total, library) =>
                                    total + library.students_count,
                                  0,
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100">
                          <div className="card-body d-flex align-items-center">
                            <div
                              className="avatar bg-label-warning rounded me-3 d-flex align-items-center justify-content-center"
                              style={{
                                width: "70px",
                                height: "70px",
                                minWidth: "70px",
                              }}
                            >
                              <i className="ri-layout-grid-line fs-2"></i>
                            </div>
                            <div>
                              <small className="text-muted">Total Seats</small>
                              <h3 className="mb-0">
                                {libraries.reduce(
                                  (total, library) =>
                                    total + library.seats_count,
                                  0,
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="card border-0 shadow-sm my-3">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                            <div>
                              <h4 className="text-primary mb-0">Libraries</h4>
                              <small className="text-muted">
                                Manage all library branches
                              </small>
                            </div>

                            <div className="d-flex gap-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search library..."
                                style={{ width: "250px" }}
                                onInput={(e) => setSearch(e.target.value)}
                              />

                              {hasAccess("/library/add") && (
                                <button
                                  className="btn btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#addNewLibrary"
                                >
                                  <i className="ri-add-line me-1"></i>
                                  Add Library
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-hover align-middle">
                              <thead className="table-light">
                                <tr>
                                  <th>#</th>
                                  <th>Library</th>
                                  <th>Contact</th>
                                  <th>Seat Charge</th>
                                  <th>Students</th>
                                  <th>Seats</th>
                                  <th>Occupancy</th>
                                  <th>Status</th>
                                  <th className="text-center">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredLibraries?.length > 0 ? (
                                  filteredLibraries.map((library, index) => (
                                    <tr key={library.id}>
                                      <td>{index + 1}</td>
                                      <td
                                        style={{
                                          minWidth: "260px",
                                          maxWidth: "260px",
                                        }}
                                      >
                                        <div className="d-flex align-items-start">
                                          <div
                                            className="rounded-circle bg-label-primary d-flex align-items-center justify-content-center me-2"
                                            style={{
                                              width: "40px",
                                              height: "40px",
                                              minWidth: "40px",
                                            }}
                                          >
                                            <i className="ri-building-line"></i>
                                          </div>

                                          <div className="overflow-hidden">
                                            <div
                                              className="fw-semibold text-primary text-truncate"
                                              title={library.name}
                                            >
                                              {library.name}
                                            </div>

                                            <small
                                              className="text-muted d-block text-truncate"
                                              title={library.address}
                                            >
                                              <i className="ri-map-pin-line me-1"></i>
                                              {library.address}
                                            </small>
                                          </div>
                                        </div>
                                      </td>
                                      <td>{library?.mobile}</td>
                                      <td>&#8377;{library?.seat_charge}</td>
                                      <td>{library?.students_count}</td>
                                      <td>{library?.seats_count}</td>
                                      <td style={{ minWidth: "150px" }}>
                                        <div
                                          className="progress"
                                          style={{ height: "8px" }}
                                        >
                                          <div
                                            className="progress-bar"
                                            style={{
                                              width: `${
                                                library.seats_count > 0
                                                  ? (library.students_count /
                                                      library.seats_count) *
                                                    100
                                                  : 0
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <small className="fw-semibold text-muted">
                                          {Math.round(
                                            (library.students_count /
                                              (library.seats_count || 1)) *
                                              100,
                                          )}
                                          % Occupied
                                        </small>
                                      </td>
                                      <td>
                                        {hasAccess("/library/status") && (
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input fs-5 "
                                              type="checkbox"
                                              role="switch"
                                              id="switchCheckDefault"
                                              checked={
                                                library?.status == "1" && true
                                              }
                                              onChange={() =>
                                                handleStatusChange(library?.id)
                                              }
                                            />
                                          </div>
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <div className="d-flex justify-content-center gap-1">
                                          {hasAccess("/library/update") && (
                                            <button
                                              className="btn btn-sm btn-icon btn-label-info"
                                              onClick={() =>
                                                setModalData(library)
                                              }
                                              data-bs-toggle="modal"
                                              data-bs-target="#editLibrary"
                                            >
                                              <i className="ri-pencil-line"></i>
                                            </button>
                                          )}
                                          {hasAccess("/library/delete") && (
                                            <button
                                              className="btn btn-sm btn-icon btn-label-danger"
                                              onClick={() =>
                                                Swal.fire({
                                                  title: "Are you sure?",
                                                  text: "This action will permanently delete !",
                                                  icon: "warning",
                                                  showCancelButton: true,
                                                  confirmButtonColor: "#d33",
                                                  cancelButtonColor: "#6c757d",
                                                  confirmButtonText:
                                                    "Yes, delete it!",
                                                  cancelButtonText: "Cancel",
                                                }).then(async (result) => {
                                                  if (result.isConfirmed) {
                                                    deleteLibrary(library?.id);
                                                  }
                                                })
                                              }
                                            >
                                              <i className="ri-delete-bin-line"></i>
                                            </button>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="9">
                                      <div className="text-center py-5">
                                        <i className="ri-building-line fs-1 text-muted"></i>
                                        <h6 className="mt-2">
                                          No Libraries Found
                                        </h6>
                                        <p className="text-muted mb-0">
                                          Try adjusting your search criteria.
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addNewLibrary"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={createLibrary}>
              <div className="modal-header bg-label-primary py-3 ">
                <h1 className="modal-title fs-5">Add Library</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    placeholder="Enter Library Name"
                    name="name"
                  />
                  <label className="">Library Name</label>
                </div>

                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Contact Number"
                    name="mobile"
                  />
                  <label className="">Contact No</label>
                </div>
                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <textarea
                    className="form-control input-uppercase"
                    rows="2"
                    placeholder="Enter Library Address"
                    name="address"
                  ></textarea>
                  <label className="">Address</label>
                </div>
                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Seats"
                    name="seats"
                  />
                  <label className="">Seats</label>
                </div>
                <div className="col-md-12 form-floating form-floating-outline mb-3">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Seat Charge"
                    name="seat_charge"
                  />
                  <label className="">Seat Charge</label>
                </div>
              </div>
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editLibrary"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-3">
              <h3 className="modal-title fs-5" id="exampleModalLabel">
                Edit Library
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form className="row g-3 p-3" onSubmit={updateLibrary}>
                <input type="hidden" name="id" value={modalData?.id} />
                <div className="col-md-6 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    placeholder="Enter Library Name"
                    name="name"
                    defaultValue={modalData?.name}
                  />
                  <label className="">Library Name</label>
                </div>

                <div className="col-md-6 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Contact Number"
                    name="mobile"
                    defaultValue={modalData?.mobile}
                  />
                  <label className="">Contact No</label>
                </div>

                <div className="col-md-6 form-floating form-floating-outline">
                  <textarea
                    className="form-control input-uppercase"
                    rows="5"
                    placeholder="Enter Library Address"
                    name="address"
                    defaultValue={modalData?.address}
                  />
                  <label className="">Address</label>
                </div>
                <div className="col-md-6 form-floating form-floating-outline mb-3">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Seat Charge"
                    name="seat_charge"
                    defaultValue={modalData?.seat_charge}
                  />
                  <label className="">Seat Charge</label>
                </div>

                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Submit"
                    )}
                    {loading ? " Submitting..." : ""}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
